import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ClientService} from 'src/app/services/client.service';
import {AccountService} from 'src/app/services/account.service';
import {TranslateService} from '@ngx-translate/core';
import {MatDialog} from '@angular/material/dialog';
import {CurrencyService} from '../../../services/currency-service';
import {NotificationService} from '../../../services/notification.service';
import {AccountDTO} from '../../../model/accountDTO';
import {ClientDTO} from '../../../model/clientDTO';
import {ConfirmDTO} from '../../shared/notification/ConfirmDTO';
import {Level} from '../../shared/notification/Level';

@Component({
  selector: 'app-list-account',
  templateUrl: './list-account.component.html',
  styleUrls: ['./list-account.component.scss']
})
export class ListAccountComponent implements OnInit {

  @Input() client: ClientDTO;
  accounts: AccountDTO[] = [];
  isLoading = false;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private notificationService: NotificationService,
    private clientService: ClientService,
    private accountService: AccountService,
    public dialog: MatDialog,
    public currencyService: CurrencyService,
    public translate: TranslateService) {
    translate.use('nl');
  }

  ngOnInit() {
    this.getAccounts(this.client.id);
  }

  getAccounts(clientId) {
    this.isLoading = true;
    this.accountService.clientAccounts(clientId).subscribe((data) => {
      this.accounts = data;
      this.isLoading = false;
    });
  }

  delete(account: any, event: MouseEvent) {
    event.stopPropagation();
    this.notificationService.confirm({header: 'rekening verwijderen?', ok: 'verwijderen'}).then(() => {
      this.accountService.delete(account.id).subscribe(() => {
        this.accounts.splice(this.accounts.indexOf(account), 1); });
    });
  }

  openManualModal(account: AccountDTO, event: MouseEvent) {
    event.stopPropagation();
    const data: ConfirmDTO = {
      header: 'wilt u handmatig transacties toevoegen?',
      body: 'deze ' + account.accountCategory.name.toLowerCase() + '-rekening is handmatig toegevoegd <br>  daarom kunnen transacties handmatig worden toegevoegd',
      ok: 'transacties toevoegen',
      level: Level.ADD
    };
    this.notificationService.confirm(data)
      .then(() => this.router.navigate([`/rekening/${account.id}/handmatig-transacties-toevoegen`]));
  }
}
